// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es6.reflect.get-own-property-descriptor.js
// module id = 698
// module chunks = 0